/** Must stay aligned with Django AUTH_PASSWORD_VALIDATORS and set-password / reset flows. */
export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_REQUIREMENTS = [
  { id: "length", label: `At least ${PASSWORD_MIN_LENGTH} characters` },
  { id: "numeric", label: "Cannot be entirely numbers" },
  { id: "common", label: "Avoid common passwords (e.g. password123)" },
  { id: "similar", label: "Not too similar to your email or username" },
] as const;

export function validatePasswordClient(value: string): string[] {
  const errors: string[] = [];
  if (!value || value.length < PASSWORD_MIN_LENGTH) {
    errors.push(`Password must be at least ${PASSWORD_MIN_LENGTH} characters.`);
  }
  if (value && /^\d+$/.test(value)) {
    errors.push("Password cannot be entirely numbers.");
  }
  return errors;
}

/** Checklist state for UI (Django validates common/similar on submit). */
export function passwordRequirementStatus(password: string) {
  return {
    length: !password || password.length >= PASSWORD_MIN_LENGTH,
    numeric: !password || !/^\d+$/.test(password),
    common: true,
    similar: true,
  };
}
